import PCSC from "./pcsc";
/* eslint-disable */
const BASE_URL = '';

const ERR_UNEX = 'Unexpected value for SW!';
const ERR_PCSC = 'PCSC Error!';

const APDU_START = '/apdu/start/$proc/$key';
const APDU_NEXT = '/apdu/next';

function Res(cmd, res) {
    return {
        type: 'apdu',
        id: cmd.id,
        apdu: res.apdu,
    };
}

function Err(cmd, err) {
    return {
        type: 'error',
        id: cmd.id,
        error: err.sw ? ERR_UNEX : ERR_PCSC,
        data: err.apdu || [err.code, err.msg],
    };
}

function ScriptEntry(cmd, attestation) {
    return {
        type: 'script',
        id: cmd.id,
        data: attestation,
    };
}

function ScriptError(cmd, err) {
    return {
        type: 'error',
        id: cmd.id,
        error: err.name,
        data: err.message,
    };
}

const UCMS = (() => {
    function start(baseUrl, proc, key) {
        let path = APDU_START.replace('$proc', proc).replace('$key', key);
        let opt = {
            credentials: 'same-origin',
        };
        return fetch(baseUrl + path, opt).then((i) => i.json());
    }

    function next(baseUrl, ucms, entries, requestBody) {
        const body = requestBody || JSON.stringify({
            session: ucms.session,
            stage: ucms.stage,
            step: ucms.step,
            entries,
        });

        let meta = {
            method: 'POST',
            credentials: 'same-origin',
            headers: new Headers({
                'Content-Type': 'application/json',
                // Distinguishes Portal-web /apdu/next calls (e.g. sponsor PIV PIN
                // submission) from mobile-app scans, so the backend only marks the
                // session consumed when the mobile actually scans the QR.
                'X-Axiad-Portal-Client': 'web',
            }),
            body: body,
        };
        return fetch(baseUrl + APDU_NEXT, meta).then((res) => res.json());
    }

    function hasSW(set, sw) {
        if (set.length == 0) return true;
        if (set.includes(sw.toLowerCase())) return true;
        if (set.includes(sw.toUpperCase())) return true;
        return false;
    }

    async function runApdu(card, process, key, hook, root) {
        // let versions = await PCSC.version();
        hook('wait_net');
        let ucms = await start(root, process, key);
        hook('wait_net_done');
        let readerName = null;

        try {
            while (ucms.stage !== 'done') {
                if (ucms.stage === 'error') {
                    if (ucms.entries.length > 0) {
                        console.error('ucms.entries:', ucms.entries);
                        throw { code: ucms.entries[0].code || ucms.entries[0].error, msg: ucms.entries[0].message };
                    } else {
                        throw { code: 'UCMS', msg: 'Unspecified error.' };
                    }
                }

                let entries = [];
                let res = null;

                hook('stage', ucms.stage);

                for (let cmd of ucms.entries) {
                    if (cmd.type === 'apdu') {
                        hook('message', cmd.message);
                        hook('wait_card', cmd);

                        /**
                         * Prevent proprietary APDUs from reaching an outdated
                         */
                        let retryDone = false;
                        let numOfRetries = 0;
                        const maxRetries = 10;
                        // retries to work around the 0x80070539 issue.
                        while (!retryDone & numOfRetries < maxRetries) {
                            numOfRetries++;
                            res = await card.send(cmd.apdu).then(
                                (v) => v,
                                (e) => {
                                    /**
                                     * Convert WHFB failures into an APDU that can be consumed
                                     * and acknowledged by UCMS.
                                     *
                                     * The resulting response APDU contains the encoded error
                                     * (with the format whfb:<error_id>[/<error_code>]) that may
                                     * then be parsed by the WHFB module in UCMS, if desired.
                                     *
                                     * UCMS can then perform a graceful cleanup of the session
                                     * and any other resources that need to be freed upon a
                                     * failed issuance.
                                     */
                                    // If it's not the last retry, send FFFF to trigger retry.
                                    // If it's the last retry, skip this and go through the error process.
                                    if (e.code === 'whfb:KeyCredentialManagerShowUIOperation/0x80070539'
                                        && numOfRetries < maxRetries) {
                                        console.debug('failed to open change pin');
                                        return { sw: 'FFFF' };
                                    }

                                    if ('code' in e && e.code.startsWith('whfb:')) {
                                        let encoder = new TextEncoder();
                                        let code = encoder.encode(e.code);
                                        let apdu = new Uint8Array(code.length + 2);
                                        let sw = '6F00';

                                        apdu.set(code, 0);
                                        apdu.set([0x6f, 0x00], code.length);
                                        apdu = base64Encode(apdu);

                                        return { apdu, sw };
                                    }
                                    throw e;
                                },
                            );
                            if (res.sw !== 'FFFF') {
                                retryDone = true;
                            }
                        }

                        hook('wait_card_done', res);

                        if (!res.apdu || (!hasSW(cmd.expected, res.sw))) {
                            entries.push(Err(cmd, res));
                            break;
                        } else if (cmd.id) {
                            entries.push(Res(cmd, res));
                        }
                    } else if (cmd.type === 'script') {
                        const script = cmd.data;
                        let finishData = "";
                        const nextWrapper = (body, rname) => {
                            finishData = body;
                            readerName = rname;
                        }
                        try {
                            await new Function('nextWrapper', 'PCSC', script)(nextWrapper, PCSC);
                            // handling special cases for WHFB.
                            if (readerName) {
                                card = await PCSC.connect(readerName);
                                // run query after the connect to WHFB
                            }
                            if (finishData.error !== undefined) {
                                console.error(finishData.error);
                                // This is the error code for FIDO2 enrollment. In future we might need some custome error code.
                                if (finishData.error.code === 0) {
                                    throw { code: 'processCancelled', msg: "Processing is canceled." }
                                }
                                throw finishData.error;
                            }
                            entries.push(ScriptEntry(cmd, JSON.stringify(finishData)));
                        } catch (e) {
                            console.error(e);
                            entries.push(ScriptError(cmd, e));
                            break;
                        }
                    } else if (cmd.type === 'error') {
                        console.error('error' + cmd.message);
                        throw { code: cmd.code || cmd.error, msg: cmd.message };
                    }
                }

                ucms = await next(root, ucms, entries);
                console.log('APUD next response:', ucms);

                if (res && res.apdu === undefined) {
                    throw res;
                }
                if (entries.length > 0 && entries.pop().error === ERR_UNEX){
                    throw { code: res.sw, msg: ERR_UNEX };
                }
            }
        } catch (e) {
            if (readerName) {
                await card.disconnect();
            }
            throw e;
        }
        if (readerName) {
            await card.disconnect();
        }
        return ucms;
    }

    async function processWorkflow(process, key, hook, root, proxy) {
        // let versions = await PCSC.version();
        hook('wait_net');
        let ucms = await start(root, process, key);
        hook('wait_net_done');
        const ctx = { card: null };

        try {
            while (ucms.stage !== 'done') {
                if (ucms.stage === 'error') {
                    if (ucms.entries.length > 0) {
                        console.error('ucms.entries:', ucms.entries);
                        throw { code: ucms.entries[0].code || ucms.entries[0].error, msg: ucms.entries[0].message };
                    } else {
                        throw { code: 'UCMS', msg: 'Unspecified error.' };
                    }
                }

                let entries = [];
                let res = null;

                hook('stage', ucms.stage);

                for (let cmd of ucms.entries) {
                    if (cmd.type === 'script') {
                        const script = cmd.data;

                        try {
                            const result = await new Function('ctx', 'PCSC', 'proxy', script)(ctx, PCSC, window.proxy);
                            // handling special cases for WHFB.

                            if (result !== undefined) {
                                console.log('result=', result);

                                entries.push(ScriptEntry(cmd, JSON.stringify(result)));                                
                            } else {
                                console.log('result undefined');
                            }
                        } catch (e) {
                            console.error(e);
                            entries.push(ScriptError(cmd, e));
                            break;
                        }
                    } else if (cmd.type === 'error') {
                        console.error('error' + cmd.message);
                        throw { code: cmd.code || cmd.error, msg: cmd.message };
                    }
                }
                
                if (entries.length === 0) {
                    console.log('No entries -> done');
                    ucms.stage = 'done';
                } else {
                    ucms = await next(root, ucms, entries);
                    console.log('APUD next response:', ucms);
    
                    if (res && res.apdu === undefined) {
                        throw res;
                    }
                    if (entries.length > 0 && entries.pop().error === ERR_UNEX){
                        throw { code: res.sw, msg: ERR_UNEX };
                    }                    
                }
            }
        } finally {
            if (ctx.card !== null) {await ctx.card.disconnect();}
        }

        return ucms;
    }

    /**
     * Enables direct encoding from Uint8Array to a Base64 string.
     *
     * This is necessary because base JavaScript strings can't express 0x00
     * as used in the SW for conversation from WHFB errors to APDU errors.
     *
     * Excerpt from:
     * https://gist.github.com/enepomnyaschih/72c423f727d395eeaa09697058238727
     */

    /*
    MIT License

    Copyright (c) 2020 Egor Nepomnyaschih

    Permission is hereby granted, free of charge, to any person obtaining a copy
    of this software and associated documentation files (the "Software"), to deal
    in the Software without restriction, including without limitation the rights
    to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
    copies of the Software, and to permit persons to whom the Software is
    furnished to do so, subject to the following conditions:

    The above copyright notice and this permission notice shall be included in all
    copies or substantial portions of the Software.

    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
    IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
    FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
    AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
    LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
    OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
    SOFTWARE.
    */

    const base64abc = [
        "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M",
        "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z",
        "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m",
        "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z",
        "0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "+", "/"
    ];

    function base64Encode(bytes) {
        let result = '', i, l = bytes.length;
        for (i = 2; i < l; i += 3) {
            result += base64abc[bytes[i - 2] >> 2];
            result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
            result += base64abc[((bytes[i - 1] & 0x0F) << 2) | (bytes[i] >> 6)];
            result += base64abc[bytes[i] & 0x3F];
        }
        if (i === l + 1) { // 1 octet yet to write
            result += base64abc[bytes[i - 2] >> 2];
            result += base64abc[(bytes[i - 2] & 0x03) << 4];
            result += "==";
        }
        if (i === l) { // 2 octets yet to write
            result += base64abc[bytes[i - 2] >> 2];
            result += base64abc[((bytes[i - 2] & 0x03) << 4) | (bytes[i - 1] >> 4)];
            result += base64abc[(bytes[i - 1] & 0x0F) << 2];
            result += "=";
        }
        return result;
    }

    // =========================================================================
    // API

    let apdu = {
        async run(card, process, key, hook = () => { }, root = BASE_URL) {
            let o = null;
            hook('start');
            try {
                o = await runApdu(card, process, key, hook, root);
            } catch (e) {
                hook('error', e);
                throw e;
            }
            hook('done');
            return o;
        },
    };

    let workflow = {
        async process(proc, key, hook = () => { }, root = BASE_URL) {
            let o = null;
            hook('start');
            try {
                o = await processWorkflow(proc, key, hook, root);
            } catch (e) {
                hook('error', e);
                throw e;
            }
            hook('done');
            return o;
        },
    };

    // -------------------------------------------------------------------------

    return {
        apdu,
        workflow,
        ...(process.env.NODE_ENV === 'test' ? {
            _testExports: {
                base64Encode,
                Res,
                Err,
                ScriptEntry,
                hasSW
            }
        } : {})
    };
})();

export default UCMS;
